import { render, staticRenderFns } from "./waterImmersion.vue?vue&type=template&id=fe4c054a&scoped=true&"
import script from "./waterImmersion.vue?vue&type=script&lang=js&"
export * from "./waterImmersion.vue?vue&type=script&lang=js&"
import style0 from "./waterImmersion.vue?vue&type=style&index=0&id=fe4c054a&lang=scss&scoped=true&"
import style1 from "./waterImmersion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4c054a",
  null
  
)

export default component.exports